
import './helps';
import './components/index';
import './blocks/index';
import './page';
AOS.init();

window.animationTestimonials = jQuery('.slider-testimonials').slick({
  centerPadding: '200px',
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplaySpeed: 5000,
  centerMode: true,
  dots: true,

  responsive: [
    {
      breakpoint: 1100,
      settings: {
        centerPadding: '0px',
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerPadding: '50px',
      }
    },
    {
      breakpoint: 501,
      settings: {
        centerPadding: '0px',
      }
    }
  ]
});
window.inAnimationTestimonials = false;
jQuery(window).on("scroll", validateIfAnimation);
function validateIfAnimation() {
  if (window.inAnimationTestimonials) {
    return;
  }
  const testimonials = jQuery('.slider-testimonials');
  for (let index = 0; index < testimonials.length; index++) {
    const element = testimonials[index];
    const position = element.getBoundingClientRect().top;

    if (position < 0) {
      window.animationTestimonials.slick('slickPlay');
      window.inAnimationTestimonials = true;
      jQuery(window).off('scroll');
      break;
    }
  }
}
jQuery(window).on('resize', validateWindow);
function validateWindow() {
  const widthWindow = window.innerWidth;
  const widthSpace = 1100;
  let padding = 0;
  if (widthWindow > widthSpace) {
    padding = (widthWindow - widthSpace) / 2;
    window.animationTestimonials.slick('slickSetOption', 'centerPadding', `${padding}px`);
  }
}
validateWindow();
jQuery('.slider-cases').slick({
  infinite: true,
  centerPadding: '160px',
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true
      }
    },
    {
      breakpoint: 501,
      settings: {
        arrows: false
      }
    }
  ]
});
jQuery('.slider-benefits-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  asNavFor: '.slider-benefits-nav'
});
jQuery('.slider-benefits-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.slider-benefits-for',
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 501,
      settings: {
        arrows: false,
        centerPadding: '40px',
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    }
  ]
});

const scrollImage2 = document.querySelector('.block-welcome__image');

if (jQuery(window).width() >= 1024) {
  jQuery("#check0").prop("checked", true);
  scrollImage2 && scrollImage2.style && (scrollImage2.style.transform = `translateY(50%)`)
}

const navbarElement = document.querySelector('nav');


console.log(jQuery('.menu-header__options'));
jQuery(".menu-header__options").on('click', function (event) {
  const element = jQuery("#navbar-dropdown");
  console.log('element', element[0]);
  if (element.hasClass("active")) {
    element.removeClass('active');
  } else {
    element.addClass('active');
  }
});
jQuery(".menu-header__menu-mobile__list__item__link").on("click", () => {
  //console.log('menu-header__menu-mobile__list__item__link');
  const menu = jQuery('#menuMobile');
  const btnShowMenu = jQuery('#btnShowMenu');
  const classActive = 'menu-header__options--active';

  if (menu.hasClass('d-flex')) {
    menu.removeClass('d-flex');
    btnShowMenu.removeClass(classActive);
  } else {
    menu.addClass('d-flex');
    btnShowMenu.addClass(classActive);
  }
});
// block-background-video__content
// block-background-video__content
// const scrollImage2 = document.querySelector('.block-welcome__image');

// jQuery('.block-background-video__content h2').attr("data-aos", "fade-in");
// jQuery('.block-background-video__content h4').attr("data-aos", "fade-in");


